import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GlobalDeviceDetailsComponent } from '@features/shopping/device-details-global/global-device-details.component';
import { DeviceDetailsOptionsComponent } from '@shared-components/device-details-options/device-details-options.component';

@Component({
  selector: 'ts-activity-1-device-details',
  templateUrl: './device-details.component.html',
  imports: [CommonModule, DeviceDetailsOptionsComponent, GlobalDeviceDetailsComponent]
})
export class DeviceDetailsComponent extends GlobalDeviceDetailsComponent implements OnInit {
  override ngOnInit(): void {
    // Intentionally empty: the <ts-global-device-details> child rendered in this template
    // is the single authoritative instance that handles its own ngOnInit() and loadDevice().
    // Calling super.ngOnInit() here would start a second parallel device-load cycle.
  }
}
